import { ColumnDescription } from "react-bootstrap-table-next";
import Table from "../../../Components/Table";
import { faEdit, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import CreateUpdateFeriados from "./CreateUpdateFeriados";
import ModalComponent from "../../../Components/Modais";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { ListarFeriadosController } from "../../../Controllers/Geral/Feriado/FeriadoController";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import { DeletarFeriadoService } from "../../../Services/Geral/Feriado/FeriadoService";
import Swal from "sweetalert2";
import { IFeriado } from "../../../Interfaces/Geral/Feriado/FeriadoInterface";
import { Spinner } from "../../../Components/Loding/SpinnerPadrao";
import moment from "moment";

export default function GestaoFeriados() {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const {
        value: lstFeriados,
        loading: lstFeriadosLoading,
        execute: updateList,
    } = useAsyncEffect(() => ListarFeriadosController(), []);

    const { execute: DeletarFeriado, loading: DeletarFeriadoLoading } =
        useAsyncCallback(DeletarFeriadoService);

    const columns: Array<ColumnDescription<IFeriado>> = [
        {
            dataField: "DS_FERIADO",
            text: "Descrição",
        },
        {
            dataField: "DT_FERIADO",
            text: "Data",
            formatter: (c, row) => {
                return moment(row.DT_FERIADO).format("DD/MM/YYYY");
            },
        },
        {
            dataField: "DS_TIPO_FERIADO",
            text: "Tipo",
        },
        {
            dataField: "DS_PAIS",
            text: "País",
        },
        {
            dataField: "DS_ESTADO",
            text: "Estado",
        },
        {
            dataField: "DS_CIDADE",
            text: "Cidade",
        },
        {
            dataField: "actions",
            text: "Ações",
            formatter: (c, row) => {
                return (
                    <div className="d-flex">
                        <button
                            className="btn btn-primary mx-1"
                            onClick={() => {
                                setShow(true);
                                setModal({
                                    headerComponent: "Editar Feriado",
                                    IconHeader: faEdit,
                                    Component: () => (
                                        <CreateUpdateFeriados
                                            setShow={setShow}
                                            row={row}
                                            updateList={updateList}
                                        />
                                    ),
                                    size: "lg",
                                });
                            }}
                        >
                            <FontAwesomeIcon icon={faEdit} />
                        </button>
                        <button
                            className="btn btn-danger"
                            onClick={() => {
                                Swal.fire({
                                    title: "Deseja apagar este feriado?",
                                    icon: "info",
                                    buttonsStyling: false,
                                    confirmButtonText:
                                        "<i class='la la-check'></i> Sim!",
                                    showCancelButton: true,
                                    cancelButtonText:
                                        "<i class='la la-thumbs-down'></i> Não",
                                    customClass: {
                                        confirmButton:
                                            "btn btn-outline-success",
                                        cancelButton: "btn btn-default",
                                    },
                                }).then((result) => {
                                    if (result.isConfirmed && row.ID_FERIADO) {
                                        DeletarFeriado(row.ID_FERIADO).then(
                                            updateList
                                        );
                                    }
                                });
                            }}
                            disabled={DeletarFeriadoLoading}
                        >
                            {DeletarFeriadoLoading ? (
                                <Spinner size="sm" />
                            ) : (
                                <FontAwesomeIcon icon={faTrash} />
                            )}
                        </button>
                    </div>
                );
            },
        },
    ];

    return (
        <>
            <div className="d-flex justify-content-between align-items-center my-2">
                <h1>Gestão de Feriados</h1>
                <button
                    className="btn btn-success"
                    onClick={() => {
                        setShow(true);
                        setModal({
                            headerComponent: "Cadastrar Feriado",
                            IconHeader: faPlus,
                            Component: () => (
                                <CreateUpdateFeriados
                                    setShow={setShow}
                                    updateList={updateList}
                                />
                            ),
                            size: "lg",
                        });
                    }}
                >
                    <FontAwesomeIcon icon={faPlus} /> Adicionar
                </button>
            </div>
            <div className="card card-body">
                <Table
                    columns={columns}
                    data={lstFeriados || []}
                    keyField="data"
                    key={`${DeletarFeriadoLoading}`}
                    loading={lstFeriadosLoading}
                    noSearch
                />
            </div>

            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </>
    );
}
